import React, { useState } from "react";
import confetti from "canvas-confetti";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ide.css";
import axios from "axios";
import Loader from "../../../../utils/loader/loader";
import ToastMessage from "../../../../utils/toasts/toastMessage";
import TestFailed from "./TestFailed";
import { useNavigate } from "react-router-dom";
import { POST_SUBMIT_CODE } from "../../../../utils/api";
import { apiRequest } from "../../../../api/apiRequest";

const ConfettiModal = ({ show, handleClose, backToMainComponent}) => {
  React.useEffect(() => {
    if (show) {
      setTimeout(() => {
        confetti({
          particleCount: 150,
          spread: 100,
          origin: { x: 0.5, y: 0.5 },
        });
      }, 200);
    }
  }, [show]);

  return (
    <Modal
      className="confetti-modal"
      show={show}
      onHide={handleClose}
      centered
      backdrop="static" // Disable backdrop
      keyboard={true}
    >
      <Modal.Header closeButton>
        <Modal.Title>Success!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-inner">
          <span>🎯</span>
          <p>
            All test cases <strong> passed </strong>successfully!
          </p>
          <Button className="btn fw500 btn-submit" onClick={backToMainComponent}>
             Pratice More
          </Button>
        </div>
        
      </Modal.Body>
    </Modal>
  );
};

const ConfettiButton = ({ onCelebrate, isDisabled }) => {
  return (
    <Button onClick={onCelebrate} className="btn fw500 btn-submit" disabled={isDisabled}>
      Submit
    </Button>
  );
};

const SuccessSubmit = ({ editorRef, challengeContent, questionID, selectedType, backToMainComponent, language }) => {
  const nav = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [explanation, setExplanation] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "",
  });

  const handleCloseErrorModal = () => {
    setShowErrorModal(false);
  };

const handleCelebrate = async () => {
  setLoading(true);
  const sourceCode = editorRef.current.getValue();
  if (!challengeContent) {
    setLoading(false);
    setToastState({
      show: true,
      message: "Please select question first",
      type: "error",
    });
    return;
  }

  const payLoad = {
    q_id: questionID ? questionID : challengeContent?.question_id,
    problem_statement: challengeContent?.description
      ? challengeContent?.description
      : challengeContent,
    code: sourceCode,
    problem_type: selectedType,
    language: language,
  };
  const result = await apiRequest("post", POST_SUBMIT_CODE, payLoad);

  setLoading(false);

  if (!result.success) {
    setToastState({
      show: true,
      message: result.message || "Unable to fetch response!",
      type: "error",
    });
    return;
  }

  const res = result.data || "";

  if (res?.evaluation?.verdict?.includes("Incorrect Solution")) {
    setShowErrorModal(true);
    localStorage.setItem("submit-error", JSON.stringify(res));
    setExplanation(res?.evaluation?.explanation);
  } else {
    localStorage.removeItem("submit-error");
    setShowModal(true);
    setIsDisabled(true);
  }
};
  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <div>
      <ConfettiButton onCelebrate={handleCelebrate} isDisabled={isDisabled} />
      <ConfettiModal show={showModal} handleClose={handleClose} backToMainComponent={backToMainComponent} />
      <Loader show={loading} />

      <ToastMessage
        show={toastState.show}
        onClose={() => setToastState({ show: false, message: "", type: "" })}
        message={toastState.message}
        type={toastState.type}
      />
      {showErrorModal && <TestFailed handleClose={handleCloseErrorModal} explanation={explanation} />}
    </div>
  );
};

export default SuccessSubmit;
